import { SupplierState } from '@interfaces';

export const supplierInitialState: SupplierState = {
  supplierLocationId: null,
};
